


























































































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue, PropSync, Watch, Prop } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { getSignatureServer, performanceServer } from '@/api/installServer';
// 安全检查单
import safetyChecklist from '@/views/inspectionContents/checklist/detailUnit/safetyChecklist.vue';
// 隐患整改单
import hiddenForm from '@/views/inspectionContents/checklist/detailUnit/hiddenForm.vue';
import Axios from 'axios';
import publishObjectPath from '@/util/configRegistry';

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import RectifyInfoDialog from '@/views/inspectionContents/checklist/unit/rectifyInfoDialog.vue';
import { deepClone } from '@/util/deepClone';
import DetailView from '@/views/doublePrevention/hazardManagement/unit/detailView.vue'; // 隐患详情

@Component({
  components: { CollapseTransition, PagingUnit, safetyChecklist, hiddenForm, RectifyInfoDialog, DetailView },
  mixins: [TableStripe],
  filters: {},
})
export default class ShowDetail extends Vue {
  @Prop() rowId!: any;
  private activeName: any = 'safetyChecklist'; // 默认显示安全检查单

  private loadingFlag: any = false;

  hazardStatus: any = {
    CREATED: '已创建',
    ISSUED: '已下发',
    RECTIFYING: '整改中',
    RECTIFIED: '已整改',
    FEEDBACK: '已反馈',
    FINISH: '已完成',
    REVIEW_FAIL: '复查不通过',
    OTHERWISE: '另行办结',
  }; // 隐患状态

  private hazardProp: any = {};
  private showHazardInfo: any = false;

  private handleClick(tab: any, event: any) {
    if (this.activeName === 'safetyChecklist') {
    } else {
      this.rowId.rectifyFormId = this.activeName;
    }
    // this.rowId.index = tab.index;
  }
  viewRectifyForm(data: any) {
    this.activeName = data.rectifyFormId;
    this.rowId.rectifyFormId = data.rectifyFormId;
  }
  hazardDetail(data: any) {
    this.hazardProp = data; // 将该行 id 传递到编辑页面
    this.hazardProp.id = data.hazardStoreId;
    this.showHazardInfo = true; // 进入表格详情页面
  }

  private hiddenData: any = [];
  private exportLoading = false; // 导出的加载
  private serverUrl = publishObjectPath.serverUrl;

  private serverUrlImg = publishObjectPath.imgPathWater;
  // 安全检查的表格
  private tableData: any = {
    receiptCode: '',
    hazardStatus: {},
  };
  // 隐患的表格
  private hazards: any = []; // 所有隐患的数组
  private hazardsHelp: any = []; // 所有隐患的数组
  private checkedHazard: any = ''; // 所有隐患的数组
  private allPeople: any = []; // 参与人员
  private previewImgList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrlImg}${item.path}`);
    });
    return arr;
  }
  private previewSignList(signData: any) {
    console.log(signData, 'signData');
    const arr: any = [];
    signData.forEach((item: any) => {
      arr.push(`data:image/png;base64,${item.signature}`);
    });
    return arr;
  }

  filterHazard(type: any) {
    this.checkedHazard = type;
    let filterArr: any = [];
    if (type === 'all') {
      filterArr = this.hazardsHelp;
    } else if (type === 'rectifying') {
      filterArr = this.hazardsHelp.filter((item: any) => item.status === 'RECTIFYING' || item.status === 'REVIEW_FAIL' || item.status === 'ISSUED');
    } else if (type === 'needFeedback') {
      filterArr = this.hazardsHelp.filter((item: any) => item.status === 'RECTIFIED');
    } else if (type === 'needReview') {
      filterArr = this.hazardsHelp.filter((item: any) => item.status === 'FEEDBACK');
    } else if (type === 'close') {
      filterArr = this.hazardsHelp.filter((item: any) => item.status === 'FINISH');
    } else {
      filterArr = this.hazardsHelp.filter((item: any) => item.status !== 'RECTIFYING' && item.status !== 'RECTIFIED' && item.status !== 'FEEDBACK' && item.status !== 'FINISH');
    }
    this.hazards = filterArr;
    console.log(this.hazards, 'this.hazards');
  }

  // 打印
  private printMethod() {
    this.$confirm('确定导出反馈单记录？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportLoading = true;
        this.exportExcelApi();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }
  private exportExcelApi() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: this.serverUrl + `/api/yunnan/security-check/task/export/rectify-feedback-from/${this.rowId.id}`, // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.exportLoading = false;
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
  }

  refreshDetail() {
    this.getHiddenFormNum();
    this.getCheckDetail();
  }
  handleMenuEditResponse() {
    this.showHazardInfo = false;
  }

  created() {
    this.getHiddenFormNum();
    this.getCheckDetail();
  }

  // 获取隐患整改单的数据（个数和详情）
  private getHiddenFormNum() {
    performanceServer.getRectifyFormDetail(this.rowId.id).then((res: any) => {
      // console.log(res);
      if (res.code === '200') {
        this.hiddenData = res.data;
        if (this.hiddenData.length > 0) {
          this.hiddenData.forEach((data: any, index: any) => {
            // console.log(data, index);
          });
        }
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  // 获取安全检查单详情
  private getCheckDetail() {
    this.loadingFlag = true;
    // 查询安全检查任务详情
    performanceServer.getTemplateDetail(this.rowId.id).then((res: any) => {
      if (res.code === '200') {
        this.loadingFlag = false;
        this.tableData = res.data; //安全检查单的数据
        // const arrExecutors: any = res.data.executors;
        // const arrJoinLeader: any = res.data.joinLeaderList;
        // const arrJoinStaff: any = res.data.joinStaffList;
        // const staffConcat: any = [...arrExecutors, ...arrJoinLeader, ...arrJoinStaff];
        this.allPeople = res.data.executors;
        this.allPeople.forEach((item: any) => {
          this.$set(item, 'signValue', '');
          this.getStaffSignatureByStaffId(item.staffId, item);
        });
        // 调接口以显示图片
        res.data.hazards.forEach((item: any, index: any) => {
          this.$set(item, 'hazardPictureFiles', []);
          this.$set(item, 'rectifyPictureFiles', []);
          if (item.hazardPicture) {
            this.getSysFile(item, 'hazardPicture');
          }
          if (item.rectifyPicture) {
            this.getSysFile(item, 'rectifyPicture');
          }
        });
        this.hazards = res.data.hazards; // 下面隐患的数据
        this.hazardsHelp = res.data.hazards; // 下面隐患的数据
      } else {
        this.loadingFlag = false;
        this.$message.warning(res.msg);
      }
    });
  }
  private getStaffSignatureByStaffId(staffId: any, data: any) {
    getSignatureServer.getStaffSignatureByStaffId(staffId).then((res: any) => {
      if (res.code === '200') {
        if (!res.data) {
          data.signValue = '';
        } else {
          data.signValue = res.data.signature;
        }
      } else {
      }
    });
  }
  /* el-image图片放大时的默认旋转 */
  private imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }

  private unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i].staffId === arr[j].staffId || arr[i].staffId === undefined || arr[j].staffId === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  private getSysFile(data: any, type: any) {
    if (type === 'hazardPicture') {
      performanceServer.getSysFile(data.hazardPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length) {
          data.hazardPictureFiles = res.data;
        }
      });
    }
    if (type === 'rectifyPicture') {
      performanceServer.getSysFile(data.rectifyPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length) {
          data.rectifyPictureFiles = res.data;
        }
      });
    }
  }

  /**
   * 返回
   * */
  private backToIndex() {
    this.$emit('backToIndex');
  }

  /**
   * 导出检查单
   * */
  printMethodCheck() {
    // 服务加载的动画
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    Axios({
      method: 'POST',
      url: this.serverUrl + `/api/yunnan/security-check/task/export/task-detail/${this.rowId.id}`, // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
    })
      .then(response => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.exportLoading = false;
        this.$message({
          type: 'success',
          message: '导出成功!',
        });
      })
      .catch(error => {
        loading.close();
        this.$message({
          type: 'error',
          message: '导出失败,请联系管理员!',
        });
        console.log(error);
      });
    /*document.documentElement.scrollTop = 0; // this.rowId.id
      const canvas: any = document.createElement('canvas'); // 生成canvas上下文
      const context = canvas.getContext('2d');
      const _articleHtml: any = document.getElementById('checkForm');
      const _w = _articleHtml.clientWidth; //获取需要导出pdf区域的宽度和高度
      let _h = _articleHtml.clientHeight;
      const scale = 1;
      if (_w > _h) {
        _h = _w;
      }
      canvas.width = _w * scale;
      canvas.height = _h * scale;
      context.scale(scale, scale);
      const opts = {
        scale: 1,
        width: _w, //dom 原始宽度
        height: _h,
        canvas: canvas,
        useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
      };
      // 以上部分都是为了强化清晰度的，放大canvas画布
      html2canvas(_articleHtml, opts).then(canvas => {
        this.createPdfAll(canvas, scale);
      });*/
  }
  createPdfAll(canvas: any, scale: any) {
    const contentWidth = canvas.width / scale;
    const contentHeight = canvas.height / scale;

    // const limit = 14000;
    //
    // if (contentHeight > limit) {
    //   const contentScale = limit / contentHeight;
    //   contentHeight = limit;
    //   contentWidth = contentScale * contentWidth;
    // }
    //
    // const pdf = new jsPDF('p', 'pt', [contentWidth, contentHeight]); //自定义宽高
    // const pageData = canvas.toDataURL('image/jpeg', 1.0); //转换图片为dataURL
    // pdf.addImage(pageData, 'JPEG', 0, 0, contentWidth, contentHeight); //添加图像到页面
    // pdf.save(`检查单  ${this.tableData.receiptCode}.pdf`);

    const pageData = canvas.toDataURL('image/jpeg', 1.0); //转换图片为dataURL
    //一页 pdf 显示 html 页面生成的 canvas高度
    const pageHeight = (contentWidth / 552.28) * 841.89;
    //未生成 pdf 的 html页面高度
    let leftHeight = contentHeight;
    //页面偏移
    let position = 0;
    //a4纸的尺寸[595.28,841.89]，html 页面生成的 canvas 在pdf中图片的宽高
    const imgWidth = 555.28;
    const imgHeight = (imgWidth / contentWidth) * contentHeight;

    const pdf = new jsPDF('p', 'pt', 'a4'); // 下载尺寸 a4 纸 比例
    //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
    //当内容未超过pdf一页显示的范围，无需分页
    if (leftHeight < pageHeight) {
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
    } else {
      while (leftHeight > 0) {
        pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
        leftHeight -= pageHeight;
        position -= 841.89;
        //避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage();
        }
      }
    }
    pdf.save(`检查单  ${this.tableData.receiptCode}.pdf`);
  }

  showRectifyForm(data: any) {
    (this.$refs.RectifyInfoDialog as any).showDialog(data);
  }
}
